// extracted by mini-css-extract-plugin
export var alertIcon = "_qk-0";